module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-25-f559c506706ec90bdd5277aeb0ae9ed6.svg";